module.exports = __webpack_public_path__ + "img/logo.a5b20c90.png";